import * as echarts from 'echarts'
export default {

  /*
  ele               --盛放图表容器
  nameData          --分析项名称
  areaData1         --分析项第一指标值
  areaData2         --分析项第二指标值
  titleData         --图表中心值
*/
  init (ele,nameData,areaData1,areaData2,titleData) {
    let circlechart = echarts.init(
      document.getElementById(ele)
    )
 
    var color = ['#51d3c5', '#43aa9f', '#ffe633', '#ffe000', '#66d9ff', '#00bfff', '#d24dff', '#bf00ff'];
    var dataStyle = {
      normal: {
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        shadowBlur: 40,
        borderWidth: 10,
        shadowColor: 'rgba(0, 0, 0, 0)' //边框阴影
      }
    };
    var placeHolderStyle = {
      normal: {
        color: '#393d50',
        label: {
          show: false
        },
        labelLine: {
          show: false
        }
      },
      emphasis: {
        color: '#393d50'
      }
    };

    //最外圈线
    function setOutCircle1 () {
      const formatData = [];

      formatData.push({
        value: 30,
        itemStyle: {
          normal: {
            borderWidth: 1,
            borderColor: '#0CD2E6',
          },
        },
      }, {
        value: 0,

      })

      return formatData;
    }

    // 次最外圈线
    function setOutCircle2 () {
      const formatData = [];

      for (var i = 0; i < 6; i++) {

        formatData.push({
          value: 30,
          itemStyle: {
            normal: {
              borderWidth: 1,
              borderColor: '#8ab3ac',

            },
          },
        }, {
          value: 20,

        })

      }

      return formatData;
    }

    let option = {
    //  backgroundColor: '#142058',
      title: {
        text: titleData,
        x: 'center',
        y: 'center',
        textStyle: {
          fontWeight: 'normal',
          fontSize: 32,
          color: "#fff",
        }
      },
      tooltip: {
        trigger: 'item',
        show: true,
        formatter: "{b} : <br/>{d}%",
        backgroundColor: "#fff", // 背景
        padding: [8, 10], //内边距
        extraCssText: 'box-shadow: 0 0 3px rgba(255, 255, 255, 0.4);', //添加阴影
      },

      series: [
        
        //最外圈线
        {
          name: 'OutCircle 1',
          type: 'pie',
          radius: ['90%', '90.01%'],
          hoverAnimation: false,
          labelLine: {
            show: false,

          },

          data: setOutCircle1(),
        },

        //次最外圈线
        {
          name: 'OutCircle 2',
          type: 'pie',
          radius: ['85%', '85.01%'],
          hoverAnimation: false,
          labelLine: {
            show: false,

          },

          data: setOutCircle2(),
        },

        //分析项第一圈
        {
          name: 'Line 1',
          type: 'pie',
          clockWise: true,
          radius: [67, 75],
          center: ['50%', '50%'],
          itemStyle: dataStyle,
          hoverAnimation: false,
          startAngle: 90,
          label: {
            borderRadius: '10',
          },
          data: [{
            value: areaData1[0], //完成量
            name: nameData[0],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: color[0]
                }, {
                  offset: 1,
                  color: color[1]
                }])
              }
            }
          },
          {
            value: areaData2[0], //未完成量
            name: '',
            tooltip: {
              show: false
            },
            itemStyle: placeHolderStyle
          },
          ]
        },

        //分析项第二圈
        {
          name: 'Line 2',
          type: 'pie',
          clockWise: true,
          radius: [57, 65],
          center: ['50%', '50%'],
          itemStyle: dataStyle,
          hoverAnimation: false,
          startAngle: 90,
          data: [{
            value: areaData1[1],
            name: nameData[1],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: color[2]
                }, {
                  offset: 1,
                  color: color[2]
                }])
              }
            }
          },
          {
            value: areaData2[1],
            name: '',
            tooltip: {
              show: false
            },
            itemStyle: placeHolderStyle
          },
          ]
        },

        //分析项第三圈
        {
          name: 'Line 3',
          type: 'pie',
          clockWise: true,
          radius: [47, 55],
          center: ['50%', '50%'],
          itemStyle: dataStyle,
          hoverAnimation: false,
          startAngle: 90,
          data: [{
            value: areaData1[2],
            name: nameData[2],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: color[4]
                }, {
                  offset: 1,
                  color: color[5]
                }]),
              }
            }
          },
          {
            value: areaData2[2],
            name: '',
            tooltip: {
              show: false
            },
            itemStyle: placeHolderStyle
          },
          ]
        },

        //分析项第四圈
        {
          name: 'Line 4',
          type: 'pie',
          clockWise: true,
          radius: [37, 45],
          center: ['50%', '50%'],
          itemStyle: dataStyle,
          hoverAnimation: false,
          startAngle: 90,
          data: [{
            value: areaData1[3],
            name: nameData[3],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: color[6]
                }, {
                  offset: 1,
                  color: color[7]
                }]),
              }
            }
          },
          {
            value: areaData2[3],
            name: '',
            tooltip: {
              show: false
            },
            itemStyle: placeHolderStyle
          },
          ]
        }

      ]
    };

    circlechart.setOption(option)
  }
}